// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_q5-0";